








































































































































































import Vue from "vue";
import { $eventsBus } from "@/main";
import SizeController from "@/app/modules/work/components/content-cotainer/tools-panel-controllers/TheContentContainerToolsPanelSizeController.vue";
import NameController from "@/app/modules/work/components/content-cotainer/tools-panel-controllers/TheContentContainerToolsPanelNameController.vue";
import FiltersController from "@/app/modules/work/components/content-cotainer/tools-panel-controllers/TheContentContainerToolsPanelFiltersController.vue";
import OverlaysController from "@/app/modules/work/components/content-cotainer/tools-panel-controllers/TheContentContainerToolsPanelOverlaysController.vue";
import MusicController from "@/app/modules/work/components/content-cotainer/tools-panel-controllers/TheContentContainerToolsPanelMusicController.vue";
import DurationController from "@/app/modules/work/components/content-cotainer/tools-panel-controllers/TheContentContainerToolsPanelDurationController.vue";
import EndCardController from "@/app/modules/work/components/content-cotainer/tools-panel-controllers/TheContentContainerToolsPanelEndCardController/TheContentContainerToolsPanelEndCardController.vue";
import vueCustomScrollbar from "vue-custom-scrollbar";

export default Vue.extend({
  name: "ToolsPanel",
  components: {
    SizeController,
    NameController,
    FiltersController,
    OverlaysController,
    MusicController,
    DurationController,
    EndCardController,
    vueCustomScrollbar,
  },
  data: function () {
    return {
      openedItemsNames: ["Output size"],
    };
  },
  computed: {
    items: function () {
      return this.$store.state.items;
    },
    previewItem: function () {
      return this.$store.state.selectedItem;
    },
    isLoadingPackshot: function () {
      if (!this.previewItem.currentVariation.checked) {
        return this.previewItem.currentVariation.isLoadingPackshot;
      } else {
        return this.items.some((i) => {
          return i.variations.some((v) => {
            return v.checked && v.isLoadingPackshot;
          });
        });
      }
    },
    isMultiSelectMode: function () {
      let checkedVariations = this.$store.state.items
        .reduce((acc, val) => acc.concat(val.variations), [])
        .filter((v) => v.checked);
      return (
        checkedVariations.length > 1 &&
        this.previewItem.currentVariation.checked
      );
    },
  },
  watch: {},
  created() {
    $eventsBus.$on("updateYandexHitByOpenedTool", () => {
      this.openedItemsNames.filter((tab) => tab !== "Output size").length === 0;
      switch (this.openedItemsNames.length) {
        case 0:
          this.updateYandexHit();
          break;
        case 1:
          this.updateYandexHit(this.openedItemsNames[0]);
          break;
        case 2:
          this.updateYandexHit(
            this.openedItemsNames.filter((name) => name !== "Output size")[0]
          );
          break;
        default:
          break;
      }
    });
    $eventsBus.$on("openToolInToolsPanel", (name) => {
      if (!this.openedItemsNames.includes(name)) {
        this.onClickArrow(name);
      }
    });
    $eventsBus.$on("scrollToTopToolsPanel", () => {
      this.scrollToTopToolsPanel();
    });
  },
  methods: {
    scrollToTopToolsPanel() {
      if (!this.$refs.scrollbar) {
        return null;
      }
      this.$refs.scrollbar.$el.scrollTop = 0;
    },
    onClickArrow(name) {
      if (!this.openedItemsNames.includes(name)) {
        this.updateYandexHit(name);
        this.closeAllMinorTabs();
        this.openedItemsNames.push(name);
        if (name === "Duration") {
          $eventsBus.$emit("showVideoRangeSlider", true);
        }
        if (name === "EndCard") {
          $eventsBus.$emit("showVideoPackshotTimeline", true);
        }
      } else {
        this.updateYandexHit();
        this.openedItemsNames.splice(this.openedItemsNames.indexOf(name), 1);
        if (name === "Duration") {
          $eventsBus.$emit("showVideoRangeSlider", false);
        }
        if (name === "EndCard") {
          $eventsBus.$emit("showVideoPackshotTimeline", false);
        }
      }
    },
    updateYandexHit(name) {
      if (!name || name === "Output size") {
        //TODO test yandex metrik
        try {
          if (this.$metrika) {
            this.$metrika.hit(this.$baseURL + "/#/");
          }
        } catch (e) {
          console.error(e);
        }
        return;
      }
      if (name !== "Output size") {
        let tab = "";
        switch (name) {
          case "Output name":
            tab = "output_name";
            break;
          case "Overlays":
            tab = "overlays";
            break;
          case "Filters":
            tab = "filters";
            break;
          case "Music":
            tab = "audio";
            break;
          case "Duration":
            tab = "duration";
            break;
          case "EndCard":
            tab = "end_card";
            break;
          default:
            break;
        }
        //TODO test yandex metrik
        try {
          if (this.$metrika) {
            this.$metrika.hit(this.$baseURL + "/#/" + tab);
          }
        } catch (e) {
          console.error(e);
        }
      }
    },
    closeAllMinorTabs() {
      this.openedItemsNames = this.openedItemsNames.filter((name) => {
        if (name === "Duration") {
          $eventsBus.$emit("showVideoRangeSlider", false);
        }
        if (name === "EndCard") {
          $eventsBus.$emit("showVideoPackshotTimeline", false);
        }
        return name === "Output size";
      });
    },
  },
});
